import makeStyles from 'e100-react-components/lib/styles/makeStyles';

const useStyles = makeStyles(({ zIndex, spacing }) => ({
  stack: {
    position: 'fixed',
    left: '50%',
    right: 'auto',
    bottom: '24px',
    transform: 'translateX(-50%)',
    width: 'max-content',
    maxWidth: `calc(100% - ${spacing(2)}px)`,
    zIndex: zIndex.snackbar,
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(),
  },
}));

export default useStyles;
